module.exports = __webpack_public_path__ + "static/img/junior.fd6510bf.png";